import type { ExternalRow, ExternalSource } from "./types";

/**
 * Silver Bulletin FLIPR (Deluxe), Oct 28, 2026 10:57 ET, read from the
 * published Datawrapper tables. The left side is the Democrat, or the
 * independent races.ts and districts.ts read as the left side; margins
 * are projected vote shares, left minus right. House rows of one-party
 * or unopposed seats carry certain odds and no margin. Paywalled:
 * internal comparison only, don't republish.
 */
const ROWS: ExternalRow[] = [
  { leftProbability: 0.6242, margin: 3.4, office: "senate", state: "AK" },
  { leftProbability: 0.0012, margin: -20.3, office: "senate", state: "AL" },
  { leftProbability: 0.0074, margin: -17.3, office: "senate", state: "AR" },
  { leftProbability: 0.9972, margin: 22.6, office: "senate", state: "CO" },
  { leftProbability: 0.9996, margin: 26.5, office: "senate", state: "DE" },
  { leftProbability: 0.141, margin: -6.2, office: "senate", state: "FL" },
  { leftProbability: 0.9781, margin: 11.4, office: "senate", state: "GA" },
  { leftProbability: 0.5743, margin: 1.0, office: "senate", state: "IA" },
  { leftProbability: 0.0021, margin: -20.4, office: "senate", state: "ID" },
  { leftProbability: 0.9978, margin: 20.1, office: "senate", state: "IL" },
  { leftProbability: 0.4912, margin: -0.1, office: "senate", state: "KS" },
  { leftProbability: 0.0029, margin: -19.4, office: "senate", state: "KY" },
  { leftProbability: 0.0445, margin: -11.0, office: "senate", state: "LA" },
  { leftProbability: 0.9999, margin: 32.0, office: "senate", state: "MA" },
  { leftProbability: 0.7118, margin: 3.2, office: "senate", state: "ME" },
  { leftProbability: 0.8074, margin: 4.9, office: "senate", state: "MI" },
  { leftProbability: 0.9229, margin: 8.0, office: "senate", state: "MN" },
  { leftProbability: 0.0363, margin: -10.1, office: "senate", state: "MS" },
  { leftProbability: 0.1633, margin: -7.7, office: "senate", state: "MT" },
  { leftProbability: 0.9574, margin: 9.7, office: "senate", state: "NC" },
  { leftProbability: 0.3458, margin: -2.4, office: "senate", state: "NE" },
  { leftProbability: 0.9351, margin: 9.4, office: "senate", state: "NH" },
  { leftProbability: 0.9971, margin: 21.9, office: "senate", state: "NJ" },
  { leftProbability: 0.9984, margin: 19.8, office: "senate", state: "NM" },
  { leftProbability: 0.6955, margin: 2.8, office: "senate", state: "OH" },
  { leftProbability: 0.0003, margin: -27.8, office: "senate", state: "OK" },
  { leftProbability: 0.9989, margin: 24.3, office: "senate", state: "OR" },
  { leftProbability: 0.9999, margin: 30.8, office: "senate", state: "RI" },
  { leftProbability: 0.3117, margin: -2.8, office: "senate", state: "SC" },
  { leftProbability: 0.007, margin: -16.3, office: "senate", state: "SD" },
  { leftProbability: 0.0003, margin: -24.1, office: "senate", state: "TN" },
  { leftProbability: 0.7083, margin: 2.9, office: "senate", state: "TX" },
  { leftProbability: 0.9967, margin: 21.3, office: "senate", state: "VA" },
  { leftProbability: 0.0001, margin: -34.5, office: "senate", state: "WV" },
  { leftProbability: 0.0, margin: -43.7, office: "senate", state: "WY" },
  { leftProbability: 0.9628, margin: 19.3, office: "governor", state: "AK" },
  { leftProbability: 0.0191, margin: -12.3, office: "governor", state: "AL" },
  { leftProbability: 0.0016, margin: -21.7, office: "governor", state: "AR" },
  { leftProbability: 0.9584, margin: 10.0, office: "governor", state: "AZ" },
  { leftProbability: 0.9998, margin: 22.8, office: "governor", state: "CA" },
  { leftProbability: 0.998, margin: 24.3, office: "governor", state: "CO" },
  { leftProbability: 0.9991, margin: 19.8, office: "governor", state: "CT" },
  { leftProbability: 0.2133, margin: -4.2, office: "governor", state: "FL" },
  { leftProbability: 0.6171, margin: 1.6, office: "governor", state: "GA" },
  { leftProbability: 0.9999, margin: 40.6, office: "governor", state: "HI" },
  { leftProbability: 0.9219, margin: 7.9, office: "governor", state: "IA" },
  { leftProbability: 0.0009, margin: -23.1, office: "governor", state: "ID" },
  { leftProbability: 0.9994, margin: 22.0, office: "governor", state: "IL" },
  { leftProbability: 0.3063, margin: -2.8, office: "governor", state: "KS" },
  { leftProbability: 0.9997, margin: 26.0, office: "governor", state: "MA" },
  { leftProbability: 0.9999, margin: 29.6, office: "governor", state: "MD" },
  { leftProbability: 0.9779, margin: 13.0, office: "governor", state: "ME" },
  { leftProbability: 0.9421, margin: 8.2, office: "governor", state: "MI" },
  { leftProbability: 0.9936, margin: 15.6, office: "governor", state: "MN" },
  { leftProbability: 0.1978, margin: -5.2, office: "governor", state: "NE" },
  { leftProbability: 0.0476, margin: -10.4, office: "governor", state: "NH" },
  { leftProbability: 0.9743, margin: 14.3, office: "governor", state: "NM" },
  { leftProbability: 0.4712, margin: -0.4, office: "governor", state: "NV" },
  { leftProbability: 0.9935, margin: 15.3, office: "governor", state: "NY" },
  { leftProbability: 0.7668, margin: 3.8, office: "governor", state: "OH" },
  { leftProbability: 0.0725, margin: -9.9, office: "governor", state: "OK" },
  { leftProbability: 0.8464, margin: 6.7, office: "governor", state: "OR" },
  { leftProbability: 0.9997, margin: 22.2, office: "governor", state: "PA" },
  { leftProbability: 0.9994, margin: 28.0, office: "governor", state: "RI" },
  { leftProbability: 0.0207, margin: -11.8, office: "governor", state: "SC" },
  { leftProbability: 0.0013, margin: -19.2, office: "governor", state: "SD" },
  { leftProbability: 0.0077, margin: -16.6, office: "governor", state: "TN" },
  { leftProbability: 0.271, margin: -3.2, office: "governor", state: "TX" },
  { leftProbability: 0.2797, margin: -3.9, office: "governor", state: "VT" },
  { leftProbability: 0.6895, margin: 2.9, office: "governor", state: "WI" },
  { leftProbability: 0.0001, margin: -33.0, office: "governor", state: "WY" },
  {
    district: "AK-AL",
    leftProbability: 0.1575,
    margin: -11.3,
    office: "house",
    state: "AK",
  },
  {
    district: "AL-01",
    leftProbability: 0.0,
    margin: -30.0,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-02",
    leftProbability: 0.2473,
    margin: -3.9,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-03",
    leftProbability: 0.0,
    margin: -43.2,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-04",
    leftProbability: 0.0,
    margin: -62.6,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-05",
    leftProbability: 0.0006,
    margin: -23.6,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-06",
    leftProbability: 0.0,
    margin: -31.6,
    office: "house",
    state: "AL",
  },
  {
    district: "AL-07",
    leftProbability: 0.9998,
    margin: 26.9,
    office: "house",
    state: "AL",
  },
  {
    district: "AR-01",
    leftProbability: 0.0,
    margin: -39.0,
    office: "house",
    state: "AR",
  },
  {
    district: "AR-02",
    leftProbability: 0.1331,
    margin: -6.3,
    office: "house",
    state: "AR",
  },
  {
    district: "AR-03",
    leftProbability: 0.0013,
    margin: -22.7,
    office: "house",
    state: "AR",
  },
  {
    district: "AR-04",
    leftProbability: 0.0,
    margin: -37.0,
    office: "house",
    state: "AR",
  },
  {
    district: "AZ-01",
    leftProbability: 0.8218,
    margin: 5.4,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-02",
    leftProbability: 0.2666,
    margin: -3.5,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-03",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-04",
    leftProbability: 0.9949,
    margin: 18.8,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-05",
    leftProbability: 0.0286,
    margin: -12.9,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-06",
    leftProbability: 0.823,
    margin: 5.2,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-07",
    leftProbability: 0.9999,
    margin: 36.5,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-08",
    leftProbability: 0.0456,
    margin: -11.5,
    office: "house",
    state: "AZ",
  },
  {
    district: "AZ-09",
    leftProbability: 0.0006,
    margin: -24.0,
    office: "house",
    state: "AZ",
  },
  {
    district: "CA-01",
    leftProbability: 0.9932,
    margin: 20.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-02",
    leftProbability: 1.0,
    margin: 37.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-03",
    leftProbability: 0.9975,
    margin: 20.5,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-04",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-05",
    leftProbability: 0.0123,
    margin: -15.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-06",
    leftProbability: 0.9902,
    margin: 18.1,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-07",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-08",
    leftProbability: 1.0,
    margin: 46.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-09",
    leftProbability: 0.9998,
    margin: 27.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-10",
    leftProbability: 1.0,
    margin: 42.7,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-11",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-12",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-13",
    leftProbability: 0.9783,
    margin: 14.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-14",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-15",
    leftProbability: 1.0,
    margin: 59.8,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-16",
    leftProbability: 1.0,
    margin: 58.5,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-17",
    leftProbability: 1.0,
    margin: 50.7,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-18",
    leftProbability: 1.0,
    margin: 42.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-19",
    leftProbability: 1.0,
    margin: 45.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-20",
    leftProbability: 0.0002,
    margin: -31.2,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-21",
    leftProbability: 0.9948,
    margin: 19.1,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-22",
    leftProbability: 0.943,
    margin: 10.8,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-23",
    leftProbability: 0.0162,
    margin: -15.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-24",
    leftProbability: 1.0,
    margin: 31.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-25",
    leftProbability: 0.9986,
    margin: 22.1,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-26",
    leftProbability: 0.9995,
    margin: 25.3,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-27",
    leftProbability: 0.9974,
    margin: 21.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-28",
    leftProbability: 1.0,
    margin: 37.9,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-29",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-30",
    leftProbability: 1.0,
    margin: 53.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-31",
    leftProbability: 0.9994,
    margin: 25.5,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-32",
    leftProbability: 1.0,
    margin: 38.4,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-33",
    leftProbability: 0.9997,
    margin: 27.1,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-34",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-35",
    leftProbability: 0.9994,
    margin: 23.6,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-36",
    leftProbability: 1.0,
    margin: 49.3,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-37",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-38",
    leftProbability: 0.9999,
    margin: 29.2,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-39",
    leftProbability: 0.9995,
    margin: 26.1,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-40",
    leftProbability: 0.0,
    margin: null,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-41",
    leftProbability: 0.9999,
    margin: 29.6,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-42",
    leftProbability: 0.999,
    margin: 22.7,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-43",
    leftProbability: 1.0,
    margin: 64.5,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-44",
    leftProbability: 1.0,
    margin: 52.0,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-45",
    leftProbability: 0.9453,
    margin: 11.8,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-46",
    leftProbability: 1.0,
    margin: 33.4,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-47",
    leftProbability: 0.9958,
    margin: 19.2,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-48",
    leftProbability: 0.9495,
    margin: 9.8,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-49",
    leftProbability: 0.999,
    margin: 22.6,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-50",
    leftProbability: 0.9999,
    margin: 27.7,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-51",
    leftProbability: 0.9999,
    margin: 29.6,
    office: "house",
    state: "CA",
  },
  {
    district: "CA-52",
    leftProbability: 1.0,
    margin: 35.3,
    office: "house",
    state: "CA",
  },
  {
    district: "CO-01",
    leftProbability: 1.0,
    margin: 62.1,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-02",
    leftProbability: 1.0,
    margin: 47.3,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-03",
    leftProbability: 0.283,
    margin: -3.3,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-04",
    leftProbability: 0.2037,
    margin: -4.8,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-05",
    leftProbability: 0.3928,
    margin: -1.5,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-06",
    leftProbability: 0.9999,
    margin: 31.2,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-07",
    leftProbability: 0.9997,
    margin: 25.6,
    office: "house",
    state: "CO",
  },
  {
    district: "CO-08",
    leftProbability: 0.867,
    margin: 6.7,
    office: "house",
    state: "CO",
  },
  {
    district: "CT-01",
    leftProbability: 1.0,
    margin: 34.8,
    office: "house",
    state: "CT",
  },
  {
    district: "CT-02",
    leftProbability: 0.9985,
    margin: 22.0,
    office: "house",
    state: "CT",
  },
  {
    district: "CT-03",
    leftProbability: 0.9998,
    margin: 27.5,
    office: "house",
    state: "CT",
  },
  {
    district: "CT-04",
    leftProbability: 1.0,
    margin: 34.8,
    office: "house",
    state: "CT",
  },
  {
    district: "CT-05",
    leftProbability: 0.993,
    margin: 15.3,
    office: "house",
    state: "CT",
  },
  {
    district: "DE-AL",
    leftProbability: 0.9999,
    margin: 27.7,
    office: "house",
    state: "DE",
  },
  {
    district: "FL-01",
    leftProbability: 0.0001,
    margin: -27.3,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-02",
    leftProbability: 0.0653,
    margin: -10.3,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-03",
    leftProbability: 0.0156,
    margin: -14.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-04",
    leftProbability: 0.0702,
    margin: -10.3,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-05",
    leftProbability: 0.0395,
    margin: -12.0,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-06",
    leftProbability: 0.0015,
    margin: -21.1,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-07",
    leftProbability: 0.3236,
    margin: -2.6,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-08",
    leftProbability: 0.0683,
    margin: -9.4,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-09",
    leftProbability: 0.3755,
    margin: -2.0,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-10",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-11",
    leftProbability: 0.0644,
    margin: -9.5,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-12",
    leftProbability: 0.0661,
    margin: -10.3,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-13",
    leftProbability: 0.3281,
    margin: -2.4,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-14",
    leftProbability: 0.8186,
    margin: 5.2,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-15",
    leftProbability: 0.0394,
    margin: -11.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-16",
    leftProbability: 0.1975,
    margin: -4.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-17",
    leftProbability: 0.0133,
    margin: -15.6,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-18",
    leftProbability: 0.0259,
    margin: -14.3,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-19",
    leftProbability: 0.0009,
    margin: -22.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-20",
    leftProbability: 1.0,
    margin: 41.5,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-21",
    leftProbability: 0.0265,
    margin: -12.2,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-22",
    leftProbability: 0.685,
    margin: 2.7,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-23",
    leftProbability: 0.9998,
    margin: 27.4,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-24",
    leftProbability: 1.0,
    margin: 52.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-25",
    leftProbability: 0.7394,
    margin: 3.8,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-26",
    leftProbability: 0.0291,
    margin: -15.1,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-27",
    leftProbability: 0.2686,
    margin: -3.5,
    office: "house",
    state: "FL",
  },
  {
    district: "FL-28",
    leftProbability: 0.015,
    margin: -16.3,
    office: "house",
    state: "FL",
  },
  {
    district: "GA-01",
    leftProbability: 0.0215,
    margin: -12.8,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-02",
    leftProbability: 0.9983,
    margin: 21.7,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-03",
    leftProbability: 0.0013,
    margin: -20.4,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-04",
    leftProbability: 1.0,
    margin: 60.4,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-05",
    leftProbability: 1.0,
    margin: 76.6,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-06",
    leftProbability: 1.0,
    margin: 57.1,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-07",
    leftProbability: 0.0211,
    margin: -13.2,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-08",
    leftProbability: 0.0001,
    margin: -27.5,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-09",
    leftProbability: 0.0001,
    margin: -28.9,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-10",
    leftProbability: 0.0041,
    margin: -18.3,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-11",
    leftProbability: 0.0084,
    margin: -14.9,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-12",
    leftProbability: 0.0377,
    margin: -12.5,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-13",
    leftProbability: 1.0,
    margin: 49.2,
    office: "house",
    state: "GA",
  },
  {
    district: "GA-14",
    leftProbability: 0.0008,
    margin: -23.0,
    office: "house",
    state: "GA",
  },
  {
    district: "HI-01",
    leftProbability: 1.0,
    margin: 42.8,
    office: "house",
    state: "HI",
  },
  {
    district: "HI-02",
    leftProbability: 1.0,
    margin: 38.7,
    office: "house",
    state: "HI",
  },
  {
    district: "IA-01",
    leftProbability: 0.8038,
    margin: 5.3,
    office: "house",
    state: "IA",
  },
  {
    district: "IA-02",
    leftProbability: 0.7021,
    margin: 2.9,
    office: "house",
    state: "IA",
  },
  {
    district: "IA-03",
    leftProbability: 0.916,
    margin: 9.1,
    office: "house",
    state: "IA",
  },
  {
    district: "IA-04",
    leftProbability: 0.0018,
    margin: -21.5,
    office: "house",
    state: "IA",
  },
  {
    district: "ID-01",
    leftProbability: 0.0001,
    margin: -30.0,
    office: "house",
    state: "ID",
  },
  {
    district: "ID-02",
    leftProbability: 0.0015,
    margin: -21.5,
    office: "house",
    state: "ID",
  },
  {
    district: "IL-01",
    leftProbability: 1.0,
    margin: 41.8,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-02",
    leftProbability: 1.0,
    margin: 44.1,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-03",
    leftProbability: 1.0,
    margin: 43.6,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-04",
    leftProbability: 0.9999,
    margin: 34.8,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-05",
    leftProbability: 1.0,
    margin: 47.1,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-06",
    leftProbability: 0.9976,
    margin: 20.2,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-07",
    leftProbability: 1.0,
    margin: 73.8,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-08",
    leftProbability: 0.9955,
    margin: 19.2,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-09",
    leftProbability: 1.0,
    margin: 46.4,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-10",
    leftProbability: 1.0,
    margin: 33.6,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-11",
    leftProbability: 0.999,
    margin: 22.7,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-12",
    leftProbability: 0.0,
    margin: -37.5,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-13",
    leftProbability: 0.9992,
    margin: 22.7,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-14",
    leftProbability: 0.9976,
    margin: 20.0,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-15",
    leftProbability: 0.0,
    margin: -36.0,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-16",
    leftProbability: 0.0053,
    margin: -18.2,
    office: "house",
    state: "IL",
  },
  {
    district: "IL-17",
    leftProbability: 0.9952,
    margin: 18.8,
    office: "house",
    state: "IL",
  },
  {
    district: "IN-01",
    leftProbability: 0.9797,
    margin: 13.8,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-02",
    leftProbability: 0.0016,
    margin: -21.8,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-03",
    leftProbability: 0.0007,
    margin: -23.0,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-04",
    leftProbability: 0.0003,
    margin: -25.5,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-05",
    leftProbability: 0.1704,
    margin: -5.3,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-06",
    leftProbability: 0.0003,
    margin: -25.1,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-07",
    leftProbability: 1.0,
    margin: 47.9,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-08",
    leftProbability: 0.0004,
    margin: -25.1,
    office: "house",
    state: "IN",
  },
  {
    district: "IN-09",
    leftProbability: 0.0013,
    margin: -21.4,
    office: "house",
    state: "IN",
  },
  {
    district: "KS-01",
    leftProbability: 0.0004,
    margin: -25.2,
    office: "house",
    state: "KS",
  },
  {
    district: "KS-02",
    leftProbability: 0.0561,
    margin: -9.4,
    office: "house",
    state: "KS",
  },
  {
    district: "KS-03",
    leftProbability: 0.9959,
    margin: 18.9,
    office: "house",
    state: "KS",
  },
  {
    district: "KS-04",
    leftProbability: 0.0181,
    margin: -14.6,
    office: "house",
    state: "KS",
  },
  {
    district: "KY-01",
    leftProbability: 0.0,
    margin: -39.2,
    office: "house",
    state: "KY",
  },
  {
    district: "KY-02",
    leftProbability: 0.0,
    margin: -35.8,
    office: "house",
    state: "KY",
  },
  {
    district: "KY-03",
    leftProbability: 0.9999,
    margin: 31.0,
    office: "house",
    state: "KY",
  },
  {
    district: "KY-04",
    leftProbability: 0.0001,
    margin: -29.0,
    office: "house",
    state: "KY",
  },
  {
    district: "KY-05",
    leftProbability: 0.0,
    margin: -55.3,
    office: "house",
    state: "KY",
  },
  {
    district: "KY-06",
    leftProbability: 0.4972,
    margin: -0.1,
    office: "house",
    state: "KY",
  },
  {
    district: "LA-01",
    leftProbability: 0.0,
    margin: -28.9,
    office: "house",
    state: "LA",
  },
  {
    district: "LA-02",
    leftProbability: 1.0,
    margin: 56.6,
    office: "house",
    state: "LA",
  },
  {
    district: "LA-03",
    leftProbability: 0.0001,
    margin: -25.7,
    office: "house",
    state: "LA",
  },
  {
    district: "LA-04",
    leftProbability: 0.0001,
    margin: -27.8,
    office: "house",
    state: "LA",
  },
  {
    district: "LA-05",
    leftProbability: 0.0003,
    margin: -10.4,
    office: "house",
    state: "LA",
  },
  {
    district: "LA-06",
    leftProbability: 0.0014,
    margin: -21.9,
    office: "house",
    state: "LA",
  },
  {
    district: "MA-01",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-02",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-03",
    leftProbability: 0.9999,
    margin: 37.7,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-04",
    leftProbability: 1.0,
    margin: 38.6,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-05",
    leftProbability: 1.0,
    margin: 77.2,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-06",
    leftProbability: 1.0,
    margin: 37.0,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-07",
    leftProbability: 1.0,
    margin: 82.4,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-08",
    leftProbability: 1.0,
    margin: 45.6,
    office: "house",
    state: "MA",
  },
  {
    district: "MA-09",
    leftProbability: 0.9996,
    margin: 25.3,
    office: "house",
    state: "MA",
  },
  {
    district: "MD-01",
    leftProbability: 0.0274,
    margin: -11.6,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-02",
    leftProbability: 1.0,
    margin: 30.5,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-03",
    leftProbability: 1.0,
    margin: 34.4,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-04",
    leftProbability: 1.0,
    margin: 77.6,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-05",
    leftProbability: 1.0,
    margin: 42.7,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-06",
    leftProbability: 0.9974,
    margin: 20.1,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-07",
    leftProbability: 1.0,
    margin: 66.7,
    office: "house",
    state: "MD",
  },
  {
    district: "MD-08",
    leftProbability: 1.0,
    margin: 61.9,
    office: "house",
    state: "MD",
  },
  {
    district: "ME-01",
    leftProbability: 0.9999,
    margin: 27.7,
    office: "house",
    state: "ME",
  },
  {
    district: "ME-02",
    leftProbability: 0.5396,
    margin: 0.6,
    office: "house",
    state: "ME",
  },
  {
    district: "MI-01",
    leftProbability: 0.043,
    margin: -11.7,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-02",
    leftProbability: 0.0008,
    margin: -24.7,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-03",
    leftProbability: 0.9965,
    margin: 19.2,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-04",
    leftProbability: 0.6562,
    margin: 2.3,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-05",
    leftProbability: 0.0021,
    margin: -21.3,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-06",
    leftProbability: 1.0,
    margin: 34.6,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-07",
    leftProbability: 0.849,
    margin: 5.4,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-08",
    leftProbability: 0.9877,
    margin: 16.8,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-09",
    leftProbability: 0.0002,
    margin: -26.8,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-10",
    leftProbability: 0.6644,
    margin: 2.5,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-11",
    leftProbability: 0.9998,
    margin: 26.5,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-12",
    leftProbability: 1.0,
    margin: 48.8,
    office: "house",
    state: "MI",
  },
  {
    district: "MI-13",
    leftProbability: 1.0,
    margin: 50.7,
    office: "house",
    state: "MI",
  },
  {
    district: "MN-01",
    leftProbability: 0.3955,
    margin: -1.5,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-02",
    leftProbability: 0.9879,
    margin: 13.4,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-03",
    leftProbability: 1.0,
    margin: 32.5,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-04",
    leftProbability: 1.0,
    margin: 44.6,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-05",
    leftProbability: 1.0,
    margin: 63.7,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-06",
    leftProbability: 0.0175,
    margin: -14.0,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-07",
    leftProbability: 0.0002,
    margin: -27.1,
    office: "house",
    state: "MN",
  },
  {
    district: "MN-08",
    leftProbability: 0.0705,
    margin: -9.9,
    office: "house",
    state: "MN",
  },
  {
    district: "MO-01",
    leftProbability: 1.0,
    margin: 41.2,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-02",
    leftProbability: 0.3853,
    margin: -1.6,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-03",
    leftProbability: 0.0233,
    margin: -13.4,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-04",
    leftProbability: 0.0018,
    margin: -21.7,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-05",
    leftProbability: 0.9963,
    margin: 18.9,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-06",
    leftProbability: 0.0063,
    margin: -17.2,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-07",
    leftProbability: 0.0,
    margin: -36.0,
    office: "house",
    state: "MO",
  },
  {
    district: "MO-08",
    leftProbability: 0.0,
    margin: -47.4,
    office: "house",
    state: "MO",
  },
  {
    district: "MS-01",
    leftProbability: 0.0001,
    margin: -26.1,
    office: "house",
    state: "MS",
  },
  {
    district: "MS-02",
    leftProbability: 0.9999,
    margin: 30.2,
    office: "house",
    state: "MS",
  },
  {
    district: "MS-03",
    leftProbability: 0.0001,
    margin: -25.6,
    office: "house",
    state: "MS",
  },
  {
    district: "MS-04",
    leftProbability: 0.0,
    margin: -35.2,
    office: "house",
    state: "MS",
  },
  {
    district: "MT-01",
    leftProbability: 0.49,
    margin: -0.1,
    office: "house",
    state: "MT",
  },
  {
    district: "MT-02",
    leftProbability: 0.0004,
    margin: -23.0,
    office: "house",
    state: "MT",
  },
  {
    district: "NC-01",
    leftProbability: 0.8114,
    margin: 4.9,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-02",
    leftProbability: 1.0,
    margin: 43.4,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-03",
    leftProbability: 0.0823,
    margin: -8.4,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-04",
    leftProbability: 1.0,
    margin: 52.8,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-05",
    leftProbability: 0.0502,
    margin: -11.0,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-06",
    leftProbability: 0.0214,
    margin: -14.4,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-07",
    leftProbability: 0.0607,
    margin: -9.2,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-08",
    leftProbability: 0.0157,
    margin: -14.9,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-09",
    leftProbability: 0.0747,
    margin: -8.2,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-10",
    leftProbability: 0.0219,
    margin: -12.0,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-11",
    leftProbability: 0.8411,
    margin: 5.9,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-12",
    leftProbability: 1.0,
    margin: 54.4,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-13",
    leftProbability: 0.0671,
    margin: -9.8,
    office: "house",
    state: "NC",
  },
  {
    district: "NC-14",
    leftProbability: 0.0432,
    margin: -11.2,
    office: "house",
    state: "NC",
  },
  {
    district: "ND-AL",
    leftProbability: 0.0001,
    margin: -30.7,
    office: "house",
    state: "ND",
  },
  {
    district: "NE-01",
    leftProbability: 0.1836,
    margin: -5.0,
    office: "house",
    state: "NE",
  },
  {
    district: "NE-02",
    leftProbability: 0.9861,
    margin: 13.5,
    office: "house",
    state: "NE",
  },
  {
    district: "NE-03",
    leftProbability: 0.0,
    margin: -44.9,
    office: "house",
    state: "NE",
  },
  {
    district: "NH-01",
    leftProbability: 0.9267,
    margin: 8.8,
    office: "house",
    state: "NH",
  },
  {
    district: "NH-02",
    leftProbability: 0.9962,
    margin: 16.6,
    office: "house",
    state: "NH",
  },
  {
    district: "NJ-01",
    leftProbability: 1.0,
    margin: 31.9,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-02",
    leftProbability: 0.0936,
    margin: -8.1,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-03",
    leftProbability: 0.999,
    margin: 22.2,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-04",
    leftProbability: 0.0008,
    margin: -24.2,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-05",
    leftProbability: 0.9971,
    margin: 21.5,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-06",
    leftProbability: 0.9994,
    margin: 24.9,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-07",
    leftProbability: 0.8739,
    margin: 6.5,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-08",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-09",
    leftProbability: 0.9905,
    margin: 16.7,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-10",
    leftProbability: 1.0,
    margin: 59.8,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-11",
    leftProbability: 0.9985,
    margin: 21.3,
    office: "house",
    state: "NJ",
  },
  {
    district: "NJ-12",
    leftProbability: 1.0,
    margin: 36.3,
    office: "house",
    state: "NJ",
  },
  {
    district: "NM-01",
    leftProbability: 0.9997,
    margin: 23.0,
    office: "house",
    state: "NM",
  },
  {
    district: "NM-02",
    leftProbability: 0.9195,
    margin: 8.8,
    office: "house",
    state: "NM",
  },
  {
    district: "NM-03",
    leftProbability: 0.9976,
    margin: 17.6,
    office: "house",
    state: "NM",
  },
  {
    district: "NV-01",
    leftProbability: 0.9409,
    margin: 10.7,
    office: "house",
    state: "NV",
  },
  {
    district: "NV-02",
    leftProbability: 0.2253,
    margin: -4.3,
    office: "house",
    state: "NV",
  },
  {
    district: "NV-03",
    leftProbability: 0.9765,
    margin: 13.6,
    office: "house",
    state: "NV",
  },
  {
    district: "NV-04",
    leftProbability: 0.9703,
    margin: 13.1,
    office: "house",
    state: "NV",
  },
  {
    district: "NY-01",
    leftProbability: 0.2581,
    margin: -4.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-02",
    leftProbability: 0.146,
    margin: -7.3,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-03",
    leftProbability: 0.9671,
    margin: 13.1,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-04",
    leftProbability: 0.9941,
    margin: 17.8,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-05",
    leftProbability: 1.0,
    margin: 57.4,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-06",
    leftProbability: 0.9998,
    margin: 28.3,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-07",
    leftProbability: 1.0,
    margin: 57.1,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-08",
    leftProbability: 1.0,
    margin: 57.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-09",
    leftProbability: 1.0,
    margin: 54.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-10",
    leftProbability: 1.0,
    margin: 71.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-11",
    leftProbability: 0.0128,
    margin: -17.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-12",
    leftProbability: 1.0,
    margin: 70.2,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-13",
    leftProbability: 1.0,
    margin: 72.4,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-14",
    leftProbability: 1.0,
    margin: 48.2,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-15",
    leftProbability: 1.0,
    margin: 61.5,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-16",
    leftProbability: 1.0,
    margin: 48.3,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-17",
    leftProbability: 0.8255,
    margin: 5.2,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-18",
    leftProbability: 0.9981,
    margin: 19.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-19",
    leftProbability: 0.9915,
    margin: 16.5,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-20",
    leftProbability: 0.9999,
    margin: 27.8,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-21",
    leftProbability: 0.265,
    margin: -3.8,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-22",
    leftProbability: 0.9992,
    margin: 23.0,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-23",
    leftProbability: 0.0074,
    margin: -15.8,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-24",
    leftProbability: 0.0089,
    margin: -16.9,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-25",
    leftProbability: 0.9999,
    margin: 29.8,
    office: "house",
    state: "NY",
  },
  {
    district: "NY-26",
    leftProbability: 1.0,
    margin: 34.3,
    office: "house",
    state: "NY",
  },
  {
    district: "OH-01",
    leftProbability: 0.9334,
    margin: 8.8,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-02",
    leftProbability: 0.0,
    margin: -37.7,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-03",
    leftProbability: 1.0,
    margin: 50.0,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-04",
    leftProbability: 0.0,
    margin: -34.1,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-05",
    leftProbability: 0.0036,
    margin: -20.8,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-06",
    leftProbability: 0.0001,
    margin: -28.3,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-07",
    leftProbability: 0.7896,
    margin: 4.6,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-08",
    leftProbability: 0.0224,
    margin: -14.2,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-09",
    leftProbability: 0.6073,
    margin: 1.5,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-10",
    leftProbability: 0.1989,
    margin: -4.7,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-11",
    leftProbability: 1.0,
    margin: 63.5,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-12",
    leftProbability: 0.0004,
    margin: -25.5,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-13",
    leftProbability: 0.9914,
    margin: 16.5,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-14",
    leftProbability: 0.0107,
    margin: -16.1,
    office: "house",
    state: "OH",
  },
  {
    district: "OH-15",
    leftProbability: 0.3514,
    margin: -2.1,
    office: "house",
    state: "OH",
  },
  {
    district: "OK-01",
    leftProbability: 0.0039,
    margin: -18.4,
    office: "house",
    state: "OK",
  },
  {
    district: "OK-02",
    leftProbability: 0.0,
    margin: -48.7,
    office: "house",
    state: "OK",
  },
  {
    district: "OK-03",
    leftProbability: 0.0,
    margin: -44.2,
    office: "house",
    state: "OK",
  },
  {
    district: "OK-04",
    leftProbability: 0.0001,
    margin: -30.4,
    office: "house",
    state: "OK",
  },
  {
    district: "OK-05",
    leftProbability: 0.0244,
    margin: -11.6,
    office: "house",
    state: "OK",
  },
  {
    district: "OR-01",
    leftProbability: 1.0,
    margin: 47.1,
    office: "house",
    state: "OR",
  },
  {
    district: "OR-02",
    leftProbability: 0.0019,
    margin: -21.5,
    office: "house",
    state: "OR",
  },
  {
    district: "OR-03",
    leftProbability: 1.0,
    margin: 53.9,
    office: "house",
    state: "OR",
  },
  {
    district: "OR-04",
    leftProbability: 0.9981,
    margin: 20.7,
    office: "house",
    state: "OR",
  },
  {
    district: "OR-05",
    leftProbability: 0.9957,
    margin: 18.3,
    office: "house",
    state: "OR",
  },
  {
    district: "OR-06",
    leftProbability: 0.9989,
    margin: 22.6,
    office: "house",
    state: "OR",
  },
  {
    district: "PA-01",
    leftProbability: 0.6631,
    margin: 2.3,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-02",
    leftProbability: 1.0,
    margin: 48.0,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-03",
    leftProbability: 1.0,
    margin: 80.6,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-04",
    leftProbability: 0.9999,
    margin: 28.6,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-05",
    leftProbability: 1.0,
    margin: 39.7,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-06",
    leftProbability: 0.9994,
    margin: 23.9,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-07",
    leftProbability: 0.8473,
    margin: 5.6,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-08",
    leftProbability: 0.818,
    margin: 4.8,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-09",
    leftProbability: 0.0001,
    margin: -30.4,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-10",
    leftProbability: 0.7719,
    margin: 3.9,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-11",
    leftProbability: 0.0221,
    margin: -13.3,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-12",
    leftProbability: 0.9999,
    margin: 28.6,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-13",
    leftProbability: 0.0,
    margin: -37.3,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-14",
    leftProbability: 0.0002,
    margin: -27.4,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-15",
    leftProbability: 0.0,
    margin: -32.9,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-16",
    leftProbability: 0.0179,
    margin: -14.6,
    office: "house",
    state: "PA",
  },
  {
    district: "PA-17",
    leftProbability: 0.9974,
    margin: 19.2,
    office: "house",
    state: "PA",
  },
  {
    district: "RI-01",
    leftProbability: 1.0,
    margin: 32.6,
    office: "house",
    state: "RI",
  },
  {
    district: "RI-02",
    leftProbability: 0.9993,
    margin: 22.4,
    office: "house",
    state: "RI",
  },
  {
    district: "SC-01",
    leftProbability: 0.2559,
    margin: -3.7,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-02",
    leftProbability: 0.0234,
    margin: -14.1,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-03",
    leftProbability: 0.0,
    margin: -34.6,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-04",
    leftProbability: 0.0048,
    margin: -17.5,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-05",
    leftProbability: 0.003,
    margin: -18.9,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-06",
    leftProbability: 1.0,
    margin: 33.7,
    office: "house",
    state: "SC",
  },
  {
    district: "SC-07",
    leftProbability: 0.0088,
    margin: -16.5,
    office: "house",
    state: "SC",
  },
  {
    district: "SD-AL",
    leftProbability: 0.0001,
    margin: -23.5,
    office: "house",
    state: "SD",
  },
  {
    district: "TN-01",
    leftProbability: 0.0,
    margin: -46.8,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-02",
    leftProbability: 0.0002,
    margin: -26.8,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-03",
    leftProbability: 0.0001,
    margin: -29.9,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-04",
    leftProbability: 0.0051,
    margin: -17.6,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-05",
    leftProbability: 0.0255,
    margin: -11.6,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-06",
    leftProbability: 0.002,
    margin: -20.2,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-07",
    leftProbability: 0.0177,
    margin: -14.3,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-08",
    leftProbability: 0.0083,
    margin: -17.9,
    office: "house",
    state: "TN",
  },
  {
    district: "TN-09",
    leftProbability: 0.0358,
    margin: -10.2,
    office: "house",
    state: "TN",
  },
  {
    district: "TX-01",
    leftProbability: 0.0,
    margin: -43.9,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-02",
    leftProbability: 0.0092,
    margin: -14.6,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-03",
    leftProbability: 0.0187,
    margin: -14.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-04",
    leftProbability: 0.0046,
    margin: -18.8,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-05",
    leftProbability: 0.0188,
    margin: -14.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-06",
    leftProbability: 0.0046,
    margin: -18.4,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-07",
    leftProbability: 0.9999,
    margin: 32.9,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-08",
    leftProbability: 0.0024,
    margin: -20.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-09",
    leftProbability: 0.0857,
    margin: -8.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-10",
    leftProbability: 0.0169,
    margin: -12.8,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-11",
    leftProbability: 0.0001,
    margin: -30.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-12",
    leftProbability: 0.0042,
    margin: -19.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-13",
    leftProbability: 0.0,
    margin: -40.2,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-14",
    leftProbability: 0.0045,
    margin: -18.5,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-15",
    leftProbability: 0.6047,
    margin: 1.6,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-16",
    leftProbability: 1.0,
    margin: 34.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-17",
    leftProbability: 0.0108,
    margin: -15.6,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-18",
    leftProbability: 1.0,
    margin: 58.4,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-19",
    leftProbability: 0.0,
    margin: -44.9,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-20",
    leftProbability: 1.0,
    margin: 41.8,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-21",
    leftProbability: 0.0192,
    margin: -14.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-22",
    leftProbability: 0.0149,
    margin: -15.2,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-23",
    leftProbability: 0.4546,
    margin: -0.7,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-24",
    leftProbability: 0.061,
    margin: -10.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-25",
    leftProbability: 0.0032,
    margin: -21.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-26",
    leftProbability: 0.0055,
    margin: -18.7,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-27",
    leftProbability: 0.0185,
    margin: -14.7,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-28",
    leftProbability: 0.9124,
    margin: 9.5,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-29",
    leftProbability: 1.0,
    margin: 42.6,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-30",
    leftProbability: 1.0,
    margin: 58.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-31",
    leftProbability: 0.0319,
    margin: -13.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-32",
    leftProbability: 0.0502,
    margin: -11.2,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-33",
    leftProbability: 1.0,
    margin: 45.9,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-34",
    leftProbability: 0.8087,
    margin: 5.3,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-35",
    leftProbability: 0.5008,
    margin: 0.0,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-36",
    leftProbability: 0.0039,
    margin: -19.5,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-37",
    leftProbability: 1.0,
    margin: 59.6,
    office: "house",
    state: "TX",
  },
  {
    district: "TX-38",
    leftProbability: 0.0145,
    margin: -15.5,
    office: "house",
    state: "TX",
  },
  {
    district: "UT-01",
    leftProbability: 0.9999,
    margin: 30.1,
    office: "house",
    state: "UT",
  },
  {
    district: "UT-02",
    leftProbability: 0.0054,
    margin: -20.7,
    office: "house",
    state: "UT",
  },
  {
    district: "UT-03",
    leftProbability: 0.0004,
    margin: -27.3,
    office: "house",
    state: "UT",
  },
  {
    district: "UT-04",
    leftProbability: 0.002,
    margin: -22.8,
    office: "house",
    state: "UT",
  },
  {
    district: "VA-01",
    leftProbability: 0.6183,
    margin: 1.6,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-02",
    leftProbability: 0.8508,
    margin: 5.9,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-03",
    leftProbability: 1.0,
    margin: 44.4,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-04",
    leftProbability: 1.0,
    margin: 42.8,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-05",
    leftProbability: 0.1369,
    margin: -5.8,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-06",
    leftProbability: 0.0059,
    margin: -17.6,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-07",
    leftProbability: 0.9945,
    margin: 17.4,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-08",
    leftProbability: 1.0,
    margin: 56.7,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-09",
    leftProbability: 0.0,
    margin: -35.6,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-10",
    leftProbability: 0.999,
    margin: 22.8,
    office: "house",
    state: "VA",
  },
  {
    district: "VA-11",
    leftProbability: 1.0,
    margin: 46.8,
    office: "house",
    state: "VA",
  },
  {
    district: "VT-AL",
    leftProbability: 1.0,
    margin: 32.1,
    office: "house",
    state: "VT",
  },
  {
    district: "WA-01",
    leftProbability: 1.0,
    margin: 38.9,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-02",
    leftProbability: 1.0,
    margin: 34.4,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-03",
    leftProbability: 0.795,
    margin: 4.9,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-04",
    leftProbability: 0.0225,
    margin: -14.2,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-05",
    leftProbability: 0.1161,
    margin: -7.2,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-06",
    leftProbability: 0.9998,
    margin: 27.5,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-07",
    leftProbability: 1.0,
    margin: 78.4,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-08",
    leftProbability: 0.9974,
    margin: 21.0,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-09",
    leftProbability: 1.0,
    margin: 49.3,
    office: "house",
    state: "WA",
  },
  {
    district: "WA-10",
    leftProbability: 0.9999,
    margin: 29.0,
    office: "house",
    state: "WA",
  },
  {
    district: "WI-01",
    leftProbability: 0.4712,
    margin: -0.4,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-02",
    leftProbability: 1.0,
    margin: null,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-03",
    leftProbability: 0.7638,
    margin: 4.0,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-04",
    leftProbability: 1.0,
    margin: 57.7,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-05",
    leftProbability: 0.0028,
    margin: -20.1,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-06",
    leftProbability: 0.0205,
    margin: -13.2,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-07",
    leftProbability: 0.0195,
    margin: -14.4,
    office: "house",
    state: "WI",
  },
  {
    district: "WI-08",
    leftProbability: 0.0415,
    margin: -12.0,
    office: "house",
    state: "WI",
  },
  {
    district: "WV-01",
    leftProbability: 0.0,
    margin: -34.8,
    office: "house",
    state: "WV",
  },
  {
    district: "WV-02",
    leftProbability: 0.0001,
    margin: -29.2,
    office: "house",
    state: "WV",
  },
  {
    district: "WY-AL",
    leftProbability: 0.0,
    margin: -38.4,
    office: "house",
    state: "WY",
  },
  { leftProbability: null, margin: 7.7, office: "house", state: "US" },
];

export const SILVER_SOURCE: ExternalSource = {
  builtIn: true,
  id: "builtin-silver-flipr",
  importedAt: "2026-10-28T14:57:00.000Z",
  label: "Silver Bulletin",
  rows: ROWS,
  topline: {
    governors: {
      demMajority: 0.832,
      repMajority: 0.075,
      tie: 0.093,
    },
    house: {
      demControl: 0.947,
      demSeats: 239.1,
      popularVote: 7.7,
    },
    senate: {
      demControl: 0.762,
      demSeats: 52.5,
      popularVote: 7.7,
    },
  },
};
